import { Link } from 'react-router-dom';
import { getVersionInfo } from '../config/version';
import DjehootyLogo from './DjehootyLogo';
import ExternalLink from './Link/ExternalLink';

/**
 * Footer component displaying application version information
 */
const Footer = () => {
  const versionInfo = getVersionInfo();

  return (
    <footer
      className="w-full mt-auto pt-4 pb-2 text-xs text-gray-600 border-t border-gray-200"
      role="contentinfo"
    >
      <div className="flex flex-col gap-1 text-sm">
        <div className="flex items-center justify-between">
          <span className="flex items-center gap-2 flex-1">
            <DjehootyLogo size={16} />
            <ExternalLink
              text="Djehooty"
              href="https://www.djehooty.org" />
            <Link to="/help#credits" className="text-gray-500 hover:underline">{versionInfo}</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
